module.exports = __webpack_public_path__ + "img/logoSafari_c.ea00a57b.svg";